import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from './styles.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export default function Problema() {
  const { t } = useTranslation('landing');

  const badItems = t('problema.bad.items', { returnObjects: true });
  const goodItems = t('problema.good.items', { returnObjects: true });

  return (
    <motion.section
      id="prob"
      className={styles.section}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className={styles.container}>
        <div className={styles.center}>
          <span className={styles.tag}>{t('problema.tag')}</span>
          <h2 className={styles.title}>{t('problema.title')}</h2>
          <p className={styles.subtitle}>{t('problema.subtitle')}</p>
        </div>
        <div className={styles.grid}>
          <div className={`${styles.card} ${styles.bad}`}>
            <div className={`${styles.cardLabel} ${styles.redLabel}`}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
              {t('problema.bad.label')}
            </div>
            <div className={styles.items}>
              {badItems.map((text, i) => (
                <div key={i} className={styles.item}>
                  <span className={styles.x}>✗</span>
                  {text}
                </div>
              ))}
            </div>
          </div>
          <div className={`${styles.card} ${styles.good}`}>
            <div className={`${styles.cardLabel} ${styles.greenLabel}`}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <circle cx="12" cy="12" r="10" />
                <polyline points="9 12 11 14 15 10" />
              </svg>
              {t('problema.good.label')}
            </div>
            <div className={styles.items}>
              {goodItems.map((text, i) => (
                <div key={i} className={styles.item}>
                  <span className={styles.check}>✓</span>
                  {text}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.quoteBox}>
          <div className={styles.quoteIcon}>💬</div>
          <div>
            <p className={styles.quoteText}>{t('problema.quote.text')}</p>
            <p className={styles.quoteSrc}>{t('problema.quote.source')}</p>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
